
import React, { useEffect, useRef } from "react";
import videojs from "video.js";
import type Player from "video.js/dist/types/player";
import { videoPoster } from "../../utils/constants";

function VideoPlayer({ link, onReady, wrapperClassName = "[&_video]:rounded-t-[20px]  w-full h-full" }: { link?: string; wrapperClassName?: string; onReady?: (args: Player) => void }) {
	const videoReference = useRef<HTMLVideoElement | null>(null);
	const playerReference = useRef<Player | null>(null);

	let videoJsOptions: any = {
		autoplay: true,
		controls: false,
		responsive: true,
		fluid: true,
		muted: true,
		navigationUI: "hide",
		preload: "metadata",
		poster: videoPoster,
	};

	useEffect(() => {
		if (!playerReference.current && link && videoReference?.current) {
			const player = videojs(videoReference.current, {
				...videoJsOptions,
			});
			player.ready(() => {
				playerReference.current = player;

				const updatedOptions = {
					...videoJsOptions,
					sources: [{ src: link, type: "application/x-mpegURL" }],
				};

				player.autoplay(updatedOptions.autoplay);
				player.src(updatedOptions.sources);

				onReady?.(player);
			});
		}
	}, [link, videoReference]);

	useEffect(() => {
		const player = playerReference.current;
		return () => {
			if (player && !player.isDisposed()) {
				player.dispose();
				playerReference.current = null;
			}
		};
	}, [playerReference]);

	return (
		<div className={wrapperClassName}>
			<video ref={videoReference} muted className="video-js" playsInline onDrag={(e) => e.preventDefault()} />
		</div>
	);
}
export default VideoPlayer;
